import TransactionStatus from "../../components/transactions/components/TransctionStatus";
import { countries } from "countries-list";
import dayjs from "dayjs";
import {
  formatCurrencyAmount,
} from "../../utils/currency";
import { capitalizeCurrencyCode } from "../../utils/helpers";
import { formatLongString } from "../../utils/formatString";

export const CURRENCIES = {
  NGN: { name: "NG Naira", symbol: "&#8358;" },
  USD: { name: "United States Dollar", symbol: "$" },
  ZAR: { name: "South African Rand", symbol: "R" },
  KES: { name: "Kenyan Shillings", symbol: "KSh" },
  ZMW: { name: "Zambian Kwacha", symbol: "ZK" },
  TZS: { name: "Tanzanian Shillings", symbol: "TSh" },
  GHS: { name: "Ghanaian Cedi", symbol: "GH₵" },
  USDC: { name: "USDC", symbol: "USDC" },
  USDT: { name: "USDT", symbol: "USDT" }
};

export const STABLE_COINS = ["USDC", "USDT"]

export const COLLECTION_CURRENCIES = {
  GHS: { name: "Ghanaian Cedi", symbol: "GH₵" },
  KES: { name: "Kenyan Shilling", symbol: "KSh" },
  NGN: { name: "Nigerian Naira", symbol: "₦" },
  TZS: { name: "Tanzanian Shilling", symbol: "TSh" },
  UGX: { name: "Ugandan Shilling", symbol: "USh" },
  USD: { name: "United States Dollar", symbol: "$" },
  ZAR: { name: "South African Rand", symbol: "R" },
  ZMW: { name: "Zambian Kwacha", symbol: "ZK" },
  USDC: { name: "USDC", symbol: "USDC" },
  USDT: { name: "USDT", symbol: "USDT" }
};

export type ProgressStatus = "idle" | "progress" | "done" | "failed";



export function formatValue(value: string): string {
  if (value === "company") {
    return "Business"
  }

  const formattedValue = value
      ?.replace(/_/g, " ")
      ?.replace(/([a-z])([A-Z])/g, "$1 $2");

  return (
      formattedValue.charAt(0).toUpperCase() +
      formattedValue.slice(1).toLowerCase()
  );
}


export const getAvailableCurrencies = (
  countryName,
  country,
  setSelectedCurrency,
) => {
  const selectedCountryData = country.find(
    (country) => country.destinationCountry === countryName,
  );
  if (selectedCountryData) {
    setSelectedCurrency(selectedCountryData.availableCurrency);
  } else {
    setSelectedCurrency([]);
  }
};

export const nextVariants = {
  hidden: {
    x: "10vw",
  },
  visible: {
    x: 0,
  },
  transition: {
    type: "spring",
    stiffness: 200,
  },
};

export const formatStatus = (data: string) => {
  if (typeof data === "string" && data === "pending") {
    return "In progress";
  } else {
    return data;
  }
};

export const formatBool = (data) => {
  if (data === true) {
    return "successful";
  } else if (data === false) {
    return "pending";
  } else {
    return "";
  }
};

export const removeLastCharacter = (arg: string) => {
  if (typeof arg === "string" && arg?.length > 0) {
    return arg.slice(0, -1);
  }
  return arg;
};

export const USDTableColumns = [
  {
    title: "Beneficiary name",
    dataIndex: "beneficiary",
    key: "beneficiary",
  },
  {
    title: "Account number",
    dataIndex: "account",
    key: "account",
  },
  {
    title: "Transaction type",
    dataIndex: "transaction_type",
    key: "transaction_type",
  },
  {
    title: "Rate",
    dataIndex: "rate",
    key: "rate",
  },
  {
    title: "Destination amount",
    dataIndex: "destinationAmount",
    key: "destinationAmount",
  },
  {
    title: "Source amount",
    dataIndex: "amount",
    key: "amount",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (text: string) => <TransactionStatus text={text} />,
  },
];

export const tableColumns = [
  {
    title: "Beneficiary name",
    dataIndex: "accountName",
    key: "accountName",
  },
  {
    title: "Account number",
    dataIndex: "accountNumber",
    key: "accountNumber",
  },

  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
  },
  {
    title: "Fee",
    dataIndex: "fee",
    key: "fee",
  },

  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (text: string) => <TransactionStatus text={text} />,
  },
];

export const payIntableColumns = [
  {
    title: "Total amount",
    dataIndex: "amount",
    key: "amount",
  },
  {
    title: "Transaction type",
    dataIndex: "type",
    key: "type",
  },
  {
    title: "Rate",
    dataIndex: "rate",
    key: "rate",
  },
  {
    title: "Transaction ID",
    dataIndex: "transId",
    key: "transId",
    render: (text: string) => formatLongString(text, 20) || "N/A",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
  },
  {
    title: "Narration",
    dataIndex: "narration",
    key: "narration",
  },
  {
    title: "Fee",
    dataIndex: "fee",
    key: "fee",
  },

  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (text: string) => <TransactionStatus text={text} />,
  },
];

export function capitalizeName(name) {
  if (typeof name !== "string" || name.length === 0) {
    return "";
  }

  return name.charAt(0).toUpperCase() + name.slice(1);
}

export const extractedString = (original) => {
  if (original === "Funding wallet from settlement balance") {
    return "Funding from settlement";
  }
  return original;
};

export const formatWalletStatementExport = async (data) => {
  return data?.map((item) => ({
      "Transaction Type": item.transactionType || 'N/A',
      "Transaction Status": item.transactionStatus || 'N/A',
      "Wallet Txn Id": item.wallet_tnx_id || 'N/A',
      "Description/Narration": item.descriptionOrNarration || 'N/A',
      "Payer/Beneficiary Name": item.payerOrBeneficiaryName || 'N/A',
      "Payer/Beneficiary Account Number": item.payerOrBeneficiaryAccountNumber || 'N/A',
      "Payer/Beneficiary Bank": item.payerOrBeneficiaryBank || 'N/A',
      "Source Amount": formatCurrencyAmount('', item.sourceAmount, 2, 'amount') || 'N/A',
      "Source Currency": item.sourceCurrency || 'N/A',
      "Transaction Amount": formatCurrencyAmount('', item.transactionAmount, 2, 'amount') || 'N/A',
      "Wallet Amount": formatCurrencyAmount('', item.walletAmount, 2, 'amount') || 'N/A',
      "Wallet Debit/Credit": item.walletDebitOrCredit || 'N/A',
      "Rate": formatCurrencyAmount('', item.rate, 2, 'rate') || 'N/A',
      "Fee": formatCurrencyAmount('', item.fee, 2, 'amount') || 'N/A',
      "Balance Before": formatCurrencyAmount('', item.balanceBefore, 2, 'amount') || 'N/A',
      "Balance After": formatCurrencyAmount('', item.balanceAfter, 2, 'amount') || 'N/A',
      "Transaction Date": dayjs(item.transactionDate).format("DD.MM.YYYY - HH:mm") || 'N/A'
  }))
}

export const initial = { opacity: 0, x: "60%" };
export const animate = { opacity: 1, x: "0" };
export const exit = { opacity: 0, x: "60%" };

export function getCountryCode(countryName: any) {
  for (const code in countries) {
    if (countries[code].name.toLowerCase() === countryName.toLowerCase()) {
      return code;
    }
  }
  return null;
}

export const EXCLUDED_CURRENCIES = ["usd", "zmw", "kes", "xof", "tzs", "cny", "ghs"];

export const EXCLUDED_CURRENCIES_FOR_VA = ["xof", "tzs", "zmw", "zar"]

export const CURRENCIES_ALLOWED_FOR_VA = ["KES", "GHS", "NGN"]

export const EXCLUDED_CURRENCIES_FOR_ID_DOC_PAYOUT = ["zmw", "tzs", "kes"]

export const ALLOWED_WALLET_CURRENCIES = ["NGN", "USD", "ZAR", "KES", "ZMW", "GHS", "USDC", "USDT"];

export const CURRENCY_CODE_WITHOUT_CLASS = ["usd", "ngn", "kes", 'ghs', "usdc", "usdt"];

export const EXCLUDED_CURRENCY_FOR_SEND = ["xof"]

export const CURRENCIES_FOR_PAYOUT_V2 = ["ghs", "kes", "zmw", "zar", "tzs", "ngn", "usdc", "usdt"]

export const CURRENCIES_TO_ALLOW_FOR_SPECIFIC_STABLE_COINS: Record<string, string[]> = {
  USDT: ["USD", "USDC"],
  USDC: ["USD", "USDT"]
}

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const accountTypes = [
  { value: "business", label: "Business" },
  { value: "personal", label: "Personal" },
];

export const vaCurrencySelectOptions = [
    {value: 'NGN', label: 'NGN'},
    {value: 'GHS', label: 'GHS'}
]

export const totalWalletTransaction = (
  amount: string | number | null | undefined, 
  fee: string | number | null | undefined, 
  currencyCode: string
) => {
  const extractNumber = (value: unknown): number => 
    typeof value === "number"
    ? value
    : typeof value === "string"
    ? parseFloat(value.replace(/[^\d.-]/g, "")) || 0
    : 0;

  const numericAmount = extractNumber(amount)
  const numericFee = extractNumber(fee)

  const totalAmount = numericAmount + numericFee
  const currencySymbol = COLLECTION_CURRENCIES[capitalizeCurrencyCode(currencyCode)].symbol || ''

  return currencySymbol + totalAmount.toFixed(2)
}

export const getErrorMessage = (error: any, fallback: string) => {
  const errorObj = error?.response?.data ?? error;
  if (typeof errorObj?.error === "string") return errorObj.error;
  if (typeof errorObj === "string") return errorObj;
  if (typeof errorObj?.message === "string") return errorObj.message;
  return fallback;
};